module.exports = __webpack_public_path__ + "media/sub2-7-5.8c4e0bf3.mp4";